import { QNCardType } from "@typings/QuickNews";

// --------------------------- Card Styling ----------------------------
export const getCardStyle = (
  index: number,
  type: QNCardType,
  isActive: boolean,
  articleIndex: number,
  videoIndex: number,
  isDragging: boolean,
  offsetY: number,
  isMobile: boolean,
  containerRef: React.RefObject<HTMLDivElement>,
) => {
  const position = index - (type === "MyFeed" ? articleIndex : videoIndex);
  const dragOffset = isDragging && isActive ? offsetY : 0;
  const baseTranslate = position * (isMobile ? 100 : 80);
  const translate =
    baseTranslate +
    (dragOffset / (containerRef.current?.clientHeight || 400)) * 80;

  let opacity = 1;
  let scale = 1;
  let translateX = 0;

  if (!isActive) {
    opacity = position === 0 ? 0.5 : 0;
    scale = position === 0 ? 0.9 : 0.85;
    translateX =
      position === 0
        ? type === "MyFeed"
          ? -55
          : 55
        : type === "MyFeed"
          ? -50
          : 50;
  } else {
    if (position === 0) {
      opacity = 1 - Math.abs(dragOffset) / 400;
      scale = 1 - Math.abs(dragOffset) / 1200;
    } else if (position === 1) {
      opacity = 0.4 + Math.abs(dragOffset) / 600;
      scale = 0.9 + Math.abs(dragOffset) / 2500;
    } else if (position === -1) {
      opacity = 0.3 + Math.abs(dragOffset) / 500;
      scale = 0.85 + Math.abs(dragOffset) / 2000;
    } else {
      opacity = 0;
      scale = position > 1 ? 0.85 : 0.8;
    }
  }

  if (isMobile && !isActive) translateX = type === "MyFeed" ? -100 : 100;

  let tilt = 0;
  if (isActive && isDragging) tilt = (dragOffset / 400) * 3;
  if (position === 1 || position < 0) tilt = (dragOffset / 400) * -3;

  return {
    transform: `translateX(${translateX}svw) translateY(${translate}svh) scale(${Math.max(0.8, Math.min(1, scale))}) rotateZ(${tilt}deg)`,
    opacity: Math.max(0, Math.min(1, opacity)),
    zIndex: !isActive
      ? 5
      : index === (type === "MyFeed" ? articleIndex : videoIndex)
        ? 10
        : position === 1
          ? 9
          : 5 - Math.abs(position),
  };
};
